module.exports = __webpack_public_path__ + "static/divider5-1e04f1aac52805467a04269c6c8e058d.svg";